import React, { Fragment } from 'react';
import I18n from 'i18n-js';
import { Button } from '@duxton-web/ui';
import PropTypes from 'prop-types';

import ModalDrawer from 'components/drawer/modal-drawer';
import { GRAB_APP_LINK } from 'constants/app-constants';

import grabAppSvg from '../../public/images/grab-app.svg';
import styles from './update-app-drawer.less';

const UpdateAppDrawer = ({
  visible,
  allowRedirect,
  handleSubmit,
  handleClose,
}) => {
  const onUpdate = () => {
    if (handleSubmit) {
      handleSubmit();
    }

    window.location.href = GRAB_APP_LINK;
  };

  const renderContent = () => (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img
          data-testid="grab-app-image"
          className={styles.image}
          src={grabAppSvg}
          alt="grab app"
        />
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.title}>{I18n.t('updateApp.title')}</p>
        <p className={styles.subtitle}>{I18n.t('updateApp.subtitle')}</p>
      </div>
      <div className={styles.buttonContainer}>
        {allowRedirect ? (
          <Fragment>
            <Button
              type="primary"
              aria-label="update version"
              data-testid="update-button"
              className={styles.submitButton}
              onClick={onUpdate}
            >
              {I18n.t('updateApp.updateButton')}
            </Button>
            <Button
              type="primary"
              aria-label="cancel"
              data-testid="cancel-button"
              className={styles.cancelButton}
              onClick={handleClose}
            >
              {I18n.t('updateApp.cancelButton')}
            </Button>
          </Fragment>
        ) : (
          <Button
            type="primary"
            size="large"
            aria-label="ok"
            data-testid="ok-button"
            onClick={handleClose}
          >
            {I18n.t('updateApp.okButton')}
          </Button>
        )}
      </div>
    </div>
  );

  return (
    <ModalDrawer
      open={visible}
      content={renderContent()}
      onClose={handleClose}
    />
  );
};
export default UpdateAppDrawer;

UpdateAppDrawer.propTypes = {
  visible: PropTypes.bool,
  allowRedirect: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
};

UpdateAppDrawer.defaultProps = {
  visible: false,
  allowRedirect: false,
  handleSubmit: null,
  handleClose: () => {},
};
